export interface BatchStatusInfo {
  icon: string;
  label: string;
  color: string;
  bgColor: string;
}

/** Capitalize first letter of each camelCase/PascalCase segment for display. */
export function toPascalCase(value: string): string {
  if (!value) return value;
  return value.charAt(0).toUpperCase() + value.slice(1);
}

const statusMap: Record<string, BatchStatusInfo> = {
  completed: { icon: "✅", label: "Completed", color: "#107C10", bgColor: "#DFF6DD" },
  staging: { icon: "🟡", label: "Staging", color: "#797600", bgColor: "#FFF4CE" },
  buffering: { icon: "⏳", label: "Buffering", color: "#986F0B", bgColor: "#FFF4CE" },
  sent: { icon: "🔵", label: "Sent", color: "#0078D4", bgColor: "#DEECF9" },
  readytosend: { icon: "🟠", label: "Ready", color: "#CA5010", bgColor: "#FED9CC" },
  failed: { icon: "🔴", label: "Failed", color: "#D13438", bgColor: "#FDE7E9" },
};

export function getStatusIconAriaHidden(): boolean {
  return true;
}

export function getStatusInfo(status: string): BatchStatusInfo {
  return statusMap[status.toLowerCase()] || { icon: "⚪", label: toPascalCase(status), color: "#605E5C", bgColor: "#F3F2F1" };
}

export function formatDateTime(dateStr: string | null, useUtc: boolean): string {
  if (!dateStr) return "—";
  const date = new Date(dateStr);
  if (useUtc) {
    return date.toISOString().replace("T", " ").substring(0, 19) + " UTC";
  }
  return date.toLocaleString();
}

export function formatPeriod(start: string | null, end: string | null): string {
  if (!start || !end) return "—";
  // Reporting boundaries are inclusive calendar labels, not instants in the viewer's time zone.
  // Preserve the stored YYYY-MM-DD even when the API serializes it with Z or an offset.
  const parseLabel = (value: string): Date | null => {
    if (!/^\d{4}-\d{2}-\d{2}(?:T|$)/.test(value)) return null;
    const label = value.substring(0, 10);
    const date = new Date(`${label}T00:00:00Z`);
    return !Number.isNaN(date.getTime()) && date.toISOString().substring(0, 10) === label ? date : null;
  };
  const s = parseLabel(start);
  const e = parseLabel(end);
  if (!s || !e) return "—";
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${monthNames[s.getUTCMonth()]} ${s.getUTCDate()} – ${monthNames[e.getUTCMonth()]} ${e.getUTCDate()}, ${e.getUTCFullYear()}`;
}
